import { defineMessages } from 'react-intl';

export const templateBuilderMessages = defineMessages({
  templateAdded: {
    defaultMessage: 'Template added!',
    id: 'uYIOITrld4',
    description: 'Toast title when a template is imported from a share link',
  },
  useInSession: {
    defaultMessage: 'Use in a session',
    id: 'fc6FDMNiZ1',
    description: 'Toast action to save the shared template and start a new session',
  },
  addTitleError: {
    defaultMessage: 'Add a title*',
    id: 'LBEGRvLY8w',
    description: 'Form validation when the template name is empty',
  },
  atLeastOneTeamRequired: {
    defaultMessage: 'At least one team must be selected when visibility is set to Team',
    id: 'N5Xpg9EsYq',
    description: 'Form validation when team visibility has no teams selected',
  },
  cannotEditSharedTemplate: {
    defaultMessage: 'You cannot edit shared templates, so we’ve created your own copy',
    id: 'QG0Vu2dMZX',
    description:
      'Toast when the user edits a shared template and receives a personal copy',
  },
  errorEditingTemplate: {
    defaultMessage: 'Error editing template',
    id: 'HUt0ks9P+K',
    description: 'Toast title when opening a template for editing fails',
  },
  couldNotSaveTemplate: {
    defaultMessage: 'Could not save template',
    id: 'ruFp9BdsN9',
    description: 'Toast title when saving a template fails',
  },
  customTemplateCopyName: {
    defaultMessage: '{templateName} (custom)',
    id: 'WFrTqhrzza',
    description:
      'Name given to the personal copy created when a user edits a Heidi, team or shared template. {templateName} is the original template name',
  },
});
